import React, {useState} from "react";
import classes from "./ReleaseActivityPage.module.css";
import {
    BUTTON,POLL_TYPE,
    WAITING_PARTICIPANTS_JOIN_TEXT
} from "../../utils/constants";
import { ReactComponent as NoActivityFeedIcon } from "../PublishedPollPage/images/NO_ACTIVITY_FEED.svg";
import ProfileIcon from "../../components/ProfileIcon";

export default function ViewMetricCardActivityFeed({data=[],  pollType=POLL_TYPE.GRADED_POLL}) {
    const [cardCollapsed, setCardCollapsed] = useState(true);


    let students = (!!data.students && !!data.students.length)
        ? [...new Map(data.students.map(obj => [obj.userId, obj])).values()].reverse()
        : [];

    let overviewStudents = students.slice(0, 4);

    return(
        <div
            className={classes.metricCard}
            style={{
                maxHeight: cardCollapsed
                    ? (students.length > 1 ? 160 : 110)
                    : (students.length > 0 ? 160 + students.length * 80 : 300),
            }}
        >
            <h2 className={classes.metricCardHeader}>
                <div className={classes.metricCardHeaderTitle}>{"View Participants"}</div>
                <span
                    tabIndex={0}
                    role={BUTTON}
                    aria-expanded={cardCollapsed ? "false" : "true"}
                    aria-controls={"participant-card-body"}
                    aria-label={cardCollapsed ? "Expand card to view all metrics" : "Collapse card to view less metrics"}
                    className={classes.metricCardControlBtn}
                    onClick={() => setCardCollapsed(!cardCollapsed)}
                >
                    {cardCollapsed ? "View All" : "View Less"}
                </span>
            </h2>

            {cardCollapsed &&
                <div
                    id={"participant-card-body"}
                    className={classes.metricCardBody}
                    style={{ paddingLeft: 0, paddingRight: 0}}
                >
                    <div className={classes.activityFeedNotification}>
                        {!!students.length
                            ? (data.students.length > 1
                                    ? `${data.students.length} participants have joined.`
                                    : `${data.students.length} participant has joined.`
                            )
                            : WAITING_PARTICIPANTS_JOIN_TEXT
                        }
                    </div>

                    {students.length > 1 &&
                        <div className={classes.row} style={{padding: "0 10px"}}>
                            {overviewStudents.map((element, index) =>
                                <div
                                    key={index}
                                    style={{
                                        transform: `translateX(-${12 * index}px)`,
                                        borderRadius: "50%",
                                        backgroundColor: "#FFF",
                                        padding: 2,
                                        zIndex: overviewStudents.length - index
                                    }}
                                >
                                    <ProfileIcon size={36} initialLetter={decodeURI(element.userName)[0]}/>
                                </div>
                            )}
                            {students.length > overviewStudents.length &&
                                <div
                                    className={classes.row}
                                    style={{
                                        justifyContent: "center",
                                        alignItems: "center",
                                        width: 36,
                                        height: 36,
                                        borderRadius: "50%",
                                        border: "1px solid #D5DADD",
                                        backgroundColor: "#FFF",
                                        transform: `translateX(-${12 * overviewStudents.length}px)`,
                                        zIndex: 0
                                    }}
                                >
                                    {students.length}
                                </div>
                            }
                        </div>
                    }
                </div>
            }


            {!cardCollapsed &&
                <div
                    id={"participant-card-body"}
                    className={classes.metricCardBody}
                    style={{paddingLeft: 0, paddingRight: 0}}
                >
                    {students.length > 1 &&
                        <div className={classes.row} style={{padding: "0 10px"}}>
                            {overviewStudents.map((element, index) =>
                                <div
                                    key={index}
                                    style={{
                                        transform: `translateX(-${12 * index}px)`,
                                        borderRadius: "50%",
                                        backgroundColor: "#FFF",
                                        padding: 2,
                                        zIndex: overviewStudents.length - index
                                    }}
                                >
                                    <ProfileIcon size={36} initialLetter={decodeURI(element.userName)[0]}/>
                                </div>
                            )}
                            {students.length > overviewStudents.length &&
                                <div
                                    className={classes.row}
                                    style={{
                                        justifyContent: "center",
                                        alignItems: "center",
                                        width: 36,
                                        height: 36,
                                        borderRadius: "50%",
                                        border: "1px solid #D5DADD",
                                        backgroundColor: "#FFF",
                                        transform: `translateX(-${12 * overviewStudents.length}px)`,
                                        zIndex: 0
                                    }}
                                >
                                    {students.length}
                                </div>
                            }
                        </div>
                    }

                    <div className={classes.activityFeedNotification}>
                        {!!students.length
                            ? (data.students.length > 1
                                    ? `${data.students.length} participants have joined.`
                                    : `${data.students.length} participant has joined.`
                            )
                            : WAITING_PARTICIPANTS_JOIN_TEXT
                        }
                    </div>


                    {!students.length &&
                        <>
                            <NoActivityFeedIcon width={100} height={100} style={{alignSelf: 'center', flexShrink: 0}}/>
                            {/*<span tabIndex={0} role={TEXTBOX}*/}
                            {/*      style={{alignSelf: 'center'}}>{WAITING_PARTICIPANTS_JOIN_TEXT}</span>*/}
                        </>
                    }
                    {!!students.length &&
                        <div className={classes.column}>
                            {students.map((element, index) => {
                                let name = "Guest"
                                if (!!element.userName) {
                                    name = decodeURI(element.userName);
                                }
                                return (
                                    <div key={index} className={`${classes.activityFeedItem} ${classes.row}`}
                                         style={{gap: 10}}>
                                        <ProfileIcon size={36} initialLetter={name[0]}/>
                                        <span>{name}</span>
                                    </div>
                                );
                            })}

                        </div>
                    }
                </div>
            }
        </div>
    );
}
